<script>
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {copyObjectProperties, sort} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import HotelModal from "./HotelModal.svelte";


    let hotels = null;
    let total = null;
    let selectedId = 0;
    let editId = null;

    const pageHeaderControls = [
        {id: 'create', name: 'NEW HOTEL', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'HOTEL', sortable: true, sort_way: 'ASC'},
        {key: 'short', title: 'SHORT', sortable: true},
        {key: 'email', title: 'EMAIL', sortable: true},
        {key: 'location', title: 'LOCATION', sortable: true},
        {key: 'contact_list_id', title: 'LIST ID', sortable: true},
        {key: 'points', title: 'POINTS', sortable: true},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            hotels = result.list;
            total = result.total;
            hotels.map(item => {
                if (!item.email) item.email = '';
            });
        }

        const onFailure = err => {
        };

        R.handle(R.hotel.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onColumnSort = ({detail}) => {
        hotels = sort(hotels, detail.key, detail.sort_way === 'DESC');
    }

    const onCreate = () => {
        editId = 0;
    }

    const onEdit = (hotel) => {
        selectedId = hotel.id;
        editId = hotel.id;
    }

    const closeEdit = param => {
        if (param) {
            let properties = ['id', 'type', 'name', 'short', 'email', 'location', 'contact_list_id', 'points', 'is_active'];

            let item = hotels.find(x => x.id == param.id);
            if (item) {
                copyObjectProperties(param, item, properties);
                hotels = hotels;
            } else {
                hotels = [copyObjectProperties(param, properties), ...hotels];
            }
        }
        editId = null;
    }

    const onDelete = hotel => {
        Alert.delete("Delete hotel", `You are about to delete hotel "${hotel.name}".\nAre you sure?`, () => deleteHotel(hotel.id));
    }

    const deleteHotel = id => {
        const onSuccess = result => {
            hotels = hotels.filter(x => x.id != result);
            Notifier.showMessage("Hotel deleted");
        }

        const onFailure = err => {
        };

        R.handle(R.hotel.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<PageHeader title="Hotels" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if hotels}
    {#if hotels.length}
        <table class="table table-list table-list-border">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each hotels as item}
                <tr class="row-hover" class:row-selected="{ selectedId === item.id }">
                    <td>
                        <span class="is-link" class:not-active={ item.is_active == 0} on:click="{ () => onEdit(item) }">
                            { item.name }
                        </span>
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.short }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.email }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.location }
                    </td>
                    <td class="text-gray hidden-xs">
                        { item.contact_list_id }
                    </td>
                    <td class="points-column text-gray text-end hidden-xs">
                        {#if item.points > 0}
                            { item.points }
                        {/if}
                    </td>
                    <td class="button-column pointer" title="delete hotel" on:click="{ () => onDelete(item) }">
                        <AppIcon icon="trash" size="16"/>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
    {:else}
        <div class="panel-simple panel-pad">
            No hotels found.
        </div>
    {/if}
{/if}
{#if editId != null}
    <HotelModal hotelId="{ editId }" closeCallback="{ closeEdit }"/>
{/if}

<style>
    .points-column {
        width: 100px;
    }
</style>